import React from 'react';
import { AD } from './admin.constants';
import { ToastState } from './admin.types';

export function AdminToast({ toast }: { toast: ToastState }) {
  if (!toast.visible) return null;
  const bg = toast.isError ? AD.RED_BG : AD.GREEN_BG;
  const color = toast.isError ? AD.RED : AD.GREEN;
  return (
    <div style={{ position: 'fixed', bottom: 32, right: 32, background: bg, color, border: '1px solid ' + color, borderRadius: 8, padding: '12px 20px', fontSize: 14, fontWeight: 600, boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 9999, fontFamily: 'Inter, system-ui, sans-serif' }}>
      {toast.message}
    </div>
  );
}
